import axios, { defaultDataSource } from '@modules/raccoon/src/api';

const endpoint = 'wiadomosciDlaKlientowSzablony';

export const wiadomosciSzablonyDataSource = () => defaultDataSource(endpoint);

export const updateWiadomoscSzablon = (id, data) =>
  axios.patch(`${endpoint}('${id}')`, data);
